module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9InJlY3RhbmdsZSIgb3ZlcmZsb3c9InZpc2libGUiIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIj4KCTxkZXNjPnJlY3RhbmdsZTwvZGVzYz4KCTxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+PC9yZWN0PgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/rectangle.svg
// module id = 707
// module chunks = 0